import {useNavigate} from 'react-router-dom'

import Style from './style'

import DefaultButton from 'shared/ui/DefaultButton'

import BackBtn from './asset/back.svg'
import ReEntryButton from 'page/ui/EventParticipantList/ui/ReEntryButton'
import useIsMobile from 'shared/model/useIsMobile'

const MainHeader = ({
	children,
	btnList,
	reEntryBtn,
	reEntryList,
	showBackBtn = true,
	mobileLayout = 'none',
	title,
	navigateLink = '',
}) => {
	const navigate = useNavigate()
	const isMobile = useIsMobile()

	const getFilteredBtnList = () => {
		if (!isMobile || mobileLayout !== 'eventParticipant') {
			return btnList
		}

		return btnList?.filter((btn) => btn.label !== 'QR 출력')
	}

	const getGroupedButtons = () => {
		const filteredBtnList = getFilteredBtnList()
		if (!isMobile || mobileLayout !== 'eventParticipant') {
			return {topButtons: filteredBtnList, bottomButtons: []}
		}

		const topButtons =
			filteredBtnList?.filter((btn) => btn.label === '대회 시작') || []
		const bottomButtons =
			filteredBtnList?.filter(
				(btn) =>
					btn.label === '대회 일시 정지' ||
					btn.label === '재시작' ||
					btn.label === '대회 종료'
			) || []

		return {topButtons, bottomButtons}
	}

	const {topButtons, bottomButtons} = getGroupedButtons()

	return (
		<Style.Wrapper $mobileLayout={mobileLayout}>
			{isMobile && mobileLayout === 'eventParticipant' ? (
				<Style.MobileBtnContainer>
					<Style.BtnTopContainer>
						{children ? (
							<h2>{children}</h2>
						) : (
							<>
								{showBackBtn ? (
									<Style.BackBtn onClick={() => navigate(navigateLink || -1)}>
										<img src={BackBtn} alt='back' />
										<p>{title ? title : '뒤로가기'}</p>
									</Style.BackBtn>
								) : (
									<div />
								)}
							</>
						)}
						<Style.BtnDiv>
							{topButtons?.map((elem, index) => (
								<DefaultButton
									key={index}
									fitWidth
									small
									deactive={elem?.deactive}
									clickEvent={elem?.clickEvent}
									loading={elem?.loading}
								>
									{elem?.label}
								</DefaultButton>
							))}
						</Style.BtnDiv>
					</Style.BtnTopContainer>

					<Style.BtnBottomContainer>
						{bottomButtons.length > 0 && (
							<Style.BtnDiv>
								{bottomButtons?.map((elem, index) => (
									<DefaultButton
										key={index}
										fitWidth
										small
										deactive={elem?.deactive}
										clickEvent={elem?.clickEvent}
										loading={elem?.loading}
									>
										{elem?.label}
									</DefaultButton>
								))}
							</Style.BtnDiv>
						)}

						{reEntryBtn && reEntryList && (
							<Style.BtnDiv>
								<ReEntryButton
									label='리엔트리 +'
									type='increase'
									reEntryList={reEntryList}
								/>
								<ReEntryButton
									label='리엔트리 -'
									type='decrease'
									reEntryList={reEntryList}
								/>
							</Style.BtnDiv>
						)}
					</Style.BtnBottomContainer>
				</Style.MobileBtnContainer>
			) : (
				<>
					{children ? (
						<h2>{children}</h2>
					) : (
						<>
							{showBackBtn ? (
								<Style.BackBtn onClick={() => navigate(navigateLink || -1)}>
									<img src={BackBtn} alt='back' />
									<p>{title ? title : '뒤로가기'}</p>
								</Style.BackBtn>
							) : (
								<div />
							)}
						</>
					)}

					<Style.BtnDiv>
						{getFilteredBtnList()?.map((elem, index) => (
							<DefaultButton
								key={index}
								fitWidth
								small
								deactive={elem?.deactive}
								clickEvent={elem?.clickEvent}
								loading={elem?.loading}
							>
								{elem?.label}
							</DefaultButton>
						))}

						{reEntryBtn && reEntryList && (
							<>
								<ReEntryButton
									label='리엔트리 +'
									type='increase'
									reEntryList={reEntryList}
								/>
								<ReEntryButton
									label='리엔트리 -'
									type='decrease'
									reEntryList={reEntryList}
								/>
							</>
						)}
					</Style.BtnDiv>
				</>
			)}
		</Style.Wrapper>
	)
}

export default MainHeader
